#@import Booking.Views.Base
#@import Booking.Presenters.PickerNotice
#@export Booking.Views.PickerNotice

class Booking.Views.PickerNotice extends Booking.Views.Base

  presenter: Booking.Presenters.PickerNotice

  templateName: 'picker_notice'

  className: 'notice'

  open: ->
    @$el.show()

  close: ->
    @$el.remove()
